import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Page } from '../../ui/layout/page';
import { Header } from '../../ui/layout/header';
import { Section } from '../../ui/layout/section';

const Styled = styled.div``;

export interface ViewProps {
  children?: ReactNode;
}

export const View: FC<ViewProps> = ({ children }) => {
  return (
    <Page header={<Header title="PDF Herunterladen" />}>
      <Section>Content...</Section>
    </Page>
  );
};
